
if (!customElements.get('cr-card-gallery')) {
  customElements.define('cr-card-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.media = this.querySelector('.cr-gallery-media');
      this.buttons = [...this.querySelectorAll('.cr-gallery-bar')];
      this.frames = [this.media.querySelector('img')];
      this.count = this.buttons.length;
      if (this.count < 2) return;
      this.current = 0;
      this.requested = 0;
      this.buttons.forEach((button, i) => button.addEventListener('click', () => this.show(i)));
      this.media.addEventListener('pointerenter', e => {
        if (e.pointerType === 'mouse') this.box = this.media.getBoundingClientRect();
      });
      this.media.addEventListener('pointermove', e => {
        if (e.pointerType !== 'mouse') return;
        const box = this.box || this.media.getBoundingClientRect();
        this.show(Math.max(0, Math.min(this.count - 1, Math.floor((e.clientX - box.left) / box.width * this.count))));
      });
      this.media.addEventListener('pointerleave', e => {
        if (e.pointerType === 'mouse') this.show(0);
      });
      this.media.addEventListener('pointerdown', e => {
        this.suppressClick = false;
        if (e.pointerType !== 'mouse') { this.start = {x:e.clientX,y:e.clientY}; }
      });
      this.media.addEventListener('pointerup', e => {
        if (!this.start) return;
        const dx = e.clientX - this.start.x;
        const dy = e.clientY - this.start.y;
        this.start = null;
        if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy)) {
          this.suppressClick = true;
          this.show((this.current + (dx < 0 ? 1 : this.count - 1)) % this.count);
        }
      });
      this.media.addEventListener('pointercancel', () => { this.start = null; });
      this.media.addEventListener('click', e => {
        if (this.suppressClick) { e.preventDefault(); this.suppressClick = false; }
      });
      this.addEventListener('keydown', e => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
        e.preventDefault();
        const index = e.key === 'Home' ? 0 : e.key === 'End' ? this.count - 1 : (this.current + (e.key === 'ArrowRight' ? 1 : this.count - 1)) % this.count;
        this.show(index); this.buttons[index].focus();
      });
    }
    prepare(i) {
        if (this.frames[i]) return;
        const template = this.querySelector(`template[data-gallery-frame="${i}"]`);
        if (!template) return;
        const frame = template.content.querySelector('img').cloneNode(true);
        this.frames[i] = frame;
        frame.addEventListener('load', () => { if (this.requested === i) this.activate(i); });
        this.media.append(frame);
    }
    show(index) {
      if (index === this.requested) return;
      this.requested = index;
      if (index) this.prepare(index);
      const frame = this.frames[index];
      if (frame && frame.complete && frame.naturalWidth) this.activate(index);
    }
    activate(index) {
      if (index === this.current) return;
      this.current = index;
      this.frames.forEach((frame,i) => frame.classList.toggle('is-current', i === index));
      this.buttons.forEach((button,i) => button.setAttribute('aria-pressed', String(i === index)));
    }
  });
}
